import React, { useState, useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { loadsAPI, savedSearchesAPI } from '../services/api';
import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Autocomplete } from '../components/ui/autocomplete';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../components/ui/select';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '../components/ui/dialog';
import {
  Search, ArrowRight, Loader2, Filter, ChevronDown, ChevronUp, Check, Truck, 
  Bookmark, BookmarkCheck, Save, X, MapPin, Navigation, RefreshCw, ArrowLeftRight
} from 'lucide-react';
import { toast } from 'sonner';

// Major US Cities for autocomplete
const US_CITIES = [
  { value: 'los_angeles_ca', label: 'Los Angeles, CA', state: 'CA' },
  { value: 'new_york_ny', label: 'New York, NY', state: 'NY' },
  { value: 'chicago_il', label: 'Chicago, IL', state: 'IL' },
  { value: 'houston_tx', label: 'Houston, TX', state: 'TX' },
  { value: 'phoenix_az', label: 'Phoenix, AZ', state: 'AZ' },
  { value: 'philadelphia_pa', label: 'Philadelphia, PA', state: 'PA' },
  { value: 'san_antonio_tx', label: 'San Antonio, TX', state: 'TX' },
  { value: 'san_diego_ca', label: 'San Diego, CA', state: 'CA' },
  { value: 'dallas_tx', label: 'Dallas, TX', state: 'TX' },
  { value: 'san_jose_ca', label: 'San Jose, CA', state: 'CA' },
  { value: 'austin_tx', label: 'Austin, TX', state: 'TX' },
  { value: 'jacksonville_fl', label: 'Jacksonville, FL', state: 'FL' },
  { value: 'fort_worth_tx', label: 'Fort Worth, TX', state: 'TX' },
  { value: 'columbus_oh', label: 'Columbus, OH', state: 'OH' },
  { value: 'charlotte_nc', label: 'Charlotte, NC', state: 'NC' },
  { value: 'san_francisco_ca', label: 'San Francisco, CA', state: 'CA' },
  { value: 'indianapolis_in', label: 'Indianapolis, IN', state: 'IN' },
  { value: 'seattle_wa', label: 'Seattle, WA', state: 'WA' },
  { value: 'denver_co', label: 'Denver, CO', state: 'CO' },
  { value: 'washington_dc', label: 'Washington, DC', state: 'DC' },
  { value: 'boston_ma', label: 'Boston, MA', state: 'MA' },
  { value: 'el_paso_tx', label: 'El Paso, TX', state: 'TX' },
  { value: 'detroit_mi', label: 'Detroit, MI', state: 'MI' },
  { value: 'nashville_tn', label: 'Nashville, TN', state: 'TN' },
  { value: 'portland_or', label: 'Portland, OR', state: 'OR' },
  { value: 'memphis_tn', label: 'Memphis, TN', state: 'TN' },
  { value: 'oklahoma_city_ok', label: 'Oklahoma City, OK', state: 'OK' },
  { value: 'las_vegas_nv', label: 'Las Vegas, NV', state: 'NV' },
  { value: 'louisville_ky', label: 'Louisville, KY', state: 'KY' },
  { value: 'baltimore_md', label: 'Baltimore, MD', state: 'MD' },
  { value: 'milwaukee_wi', label: 'Milwaukee, WI', state: 'WI' },
  { value: 'albuquerque_nm', label: 'Albuquerque, NM', state: 'NM' },
  { value: 'tucson_az', label: 'Tucson, AZ', state: 'AZ' },
  { value: 'fresno_ca', label: 'Fresno, CA', state: 'CA' },
  { value: 'sacramento_ca', label: 'Sacramento, CA', state: 'CA' },
  { value: 'mesa_az', label: 'Mesa, AZ', state: 'AZ' },
  { value: 'kansas_city_mo', label: 'Kansas City, MO', state: 'MO' },
  { value: 'atlanta_ga', label: 'Atlanta, GA', state: 'GA' },
  { value: 'long_beach_ca', label: 'Long Beach, CA', state: 'CA' },
  { value: 'omaha_ne', label: 'Omaha, NE', state: 'NE' },
  { value: 'raleigh_nc', label: 'Raleigh, NC', state: 'NC' },
  { value: 'colorado_springs_co', label: 'Colorado Springs, CO', state: 'CO' },
  { value: 'miami_fl', label: 'Miami, FL', state: 'FL' },
  { value: 'oakland_ca', label: 'Oakland, CA', state: 'CA' },
  { value: 'minneapolis_mn', label: 'Minneapolis, MN', state: 'MN' },
  { value: 'tulsa_ok', label: 'Tulsa, OK', state: 'OK' },
  { value: 'cleveland_oh', label: 'Cleveland, OH', state: 'OH' },
  { value: 'wichita_ks', label: 'Wichita, KS', state: 'KS' },
  { value: 'arlington_tx', label: 'Arlington, TX', state: 'TX' },
  { value: 'new_orleans_la', label: 'New Orleans, LA', state: 'LA' },
  { value: 'bakersfield_ca', label: 'Bakersfield, CA', state: 'CA' },
  { value: 'tampa_fl', label: 'Tampa, FL', state: 'FL' },
  { value: 'honolulu_hi', label: 'Honolulu, HI', state: 'HI' },
  { value: 'aurora_co', label: 'Aurora, CO', state: 'CO' },
  { value: 'anaheim_ca', label: 'Anaheim, CA', state: 'CA' },
  { value: 'santa_ana_ca', label: 'Santa Ana, CA', state: 'CA' },
  { value: 'st_louis_mo', label: 'St. Louis, MO', state: 'MO' },
  { value: 'riverside_ca', label: 'Riverside, CA', state: 'CA' },
  { value: 'corpus_christi_tx', label: 'Corpus Christi, TX', state: 'TX' },
  { value: 'lexington_ky', label: 'Lexington, KY', state: 'KY' },
  { value: 'pittsburgh_pa', label: 'Pittsburgh, PA', state: 'PA' },
  { value: 'anchorage_ak', label: 'Anchorage, AK', state: 'AK' },
  { value: 'stockton_ca', label: 'Stockton, CA', state: 'CA' },
  { value: 'cincinnati_oh', label: 'Cincinnati, OH', state: 'OH' },
  { value: 'st_paul_mn', label: 'St. Paul, MN', state: 'MN' },
  { value: 'toledo_oh', label: 'Toledo, OH', state: 'OH' },
  { value: 'greensboro_nc', label: 'Greensboro, NC', state: 'NC' },
  { value: 'newark_nj', label: 'Newark, NJ', state: 'NJ' },
  { value: 'plano_tx', label: 'Plano, TX', state: 'TX' },
  { value: 'henderson_nv', label: 'Henderson, NV', state: 'NV' },
  { value: 'lincoln_ne', label: 'Lincoln, NE', state: 'NE' },
  { value: 'buffalo_ny', label: 'Buffalo, NY', state: 'NY' },
  { value: 'jersey_city_nj', label: 'Jersey City, NJ', state: 'NJ' },
  { value: 'chula_vista_ca', label: 'Chula Vista, CA', state: 'CA' },
  { value: 'fort_wayne_in', label: 'Fort Wayne, IN', state: 'IN' },
  { value: 'orlando_fl', label: 'Orlando, FL', state: 'FL' },
  { value: 'st_petersburg_fl', label: 'St. Petersburg, FL', state: 'FL' },
  { value: 'chandler_az', label: 'Chandler, AZ', state: 'AZ' },
  { value: 'laredo_tx', label: 'Laredo, TX', state: 'TX' },
  { value: 'norfolk_va', label: 'Norfolk, VA', state: 'VA' },
  { value: 'durham_nc', label: 'Durham, NC', state: 'NC' },
  { value: 'madison_wi', label: 'Madison, WI', state: 'WI' },
  { value: 'lubbock_tx', label: 'Lubbock, TX', state: 'TX' },
  { value: 'irvine_ca', label: 'Irvine, CA', state: 'CA' },
  { value: 'winston_salem_nc', label: 'Winston-Salem, NC', state: 'NC' },
  { value: 'glendale_az', label: 'Glendale, AZ', state: 'AZ' },
  { value: 'garland_tx', label: 'Garland, TX', state: 'TX' },
  { value: 'hialeah_fl', label: 'Hialeah, FL', state: 'FL' },
  { value: 'reno_nv', label: 'Reno, NV', state: 'NV' },
  { value: 'chesapeake_va', label: 'Chesapeake, VA', state: 'VA' },
  { value: 'gilbert_az', label: 'Gilbert, AZ', state: 'AZ' },
  { value: 'baton_rouge_la', label: 'Baton Rouge, LA', state: 'LA' },
  { value: 'irving_tx', label: 'Irving, TX', state: 'TX' },
  { value: 'scottsdale_az', label: 'Scottsdale, AZ', state: 'AZ' },
  { value: 'north_las_vegas_nv', label: 'North Las Vegas, NV', state: 'NV' },
  { value: 'fremont_ca', label: 'Fremont, CA', state: 'CA' },
  { value: 'boise_id', label: 'Boise, ID', state: 'ID' },
  { value: 'richmond_va', label: 'Richmond, VA', state: 'VA' },
  { value: 'san_bernardino_ca', label: 'San Bernardino, CA', state: 'CA' },
  { value: 'birmingham_al', label: 'Birmingham, AL', state: 'AL' },
  { value: 'spokane_wa', label: 'Spokane, WA', state: 'WA' },
  { value: 'rochester_ny', label: 'Rochester, NY', state: 'NY' },
  { value: 'des_moines_ia', label: 'Des Moines, IA', state: 'IA' },
  { value: 'modesto_ca', label: 'Modesto, CA', state: 'CA' },
  { value: 'fayetteville_nc', label: 'Fayetteville, NC', state: 'NC' },
  { value: 'tacoma_wa', label: 'Tacoma, WA', state: 'WA' },
  { value: 'oxnard_ca', label: 'Oxnard, CA', state: 'CA' },
  { value: 'fontana_ca', label: 'Fontana, CA', state: 'CA' },
  { value: 'columbus_ga', label: 'Columbus, GA', state: 'GA' },
  { value: 'montgomery_al', label: 'Montgomery, AL', state: 'AL' },
  { value: 'moreno_valley_ca', label: 'Moreno Valley, CA', state: 'CA' },
  { value: 'shreveport_la', label: 'Shreveport, LA', state: 'LA' },
  { value: 'aurora_il', label: 'Aurora, IL', state: 'IL' },
  { value: 'yonkers_ny', label: 'Yonkers, NY', state: 'NY' },
  { value: 'akron_oh', label: 'Akron, OH', state: 'OH' },
  { value: 'huntington_beach_ca', label: 'Huntington Beach, CA', state: 'CA' },
  { value: 'little_rock_ar', label: 'Little Rock, AR', state: 'AR' },
  { value: 'augusta_ga', label: 'Augusta, GA', state: 'GA' },
  { value: 'amarillo_tx', label: 'Amarillo, TX', state: 'TX' },
  { value: 'glendale_ca', label: 'Glendale, CA', state: 'CA' },
  { value: 'mobile_al', label: 'Mobile, AL', state: 'AL' },
  { value: 'grand_rapids_mi', label: 'Grand Rapids, MI', state: 'MI' },
  { value: 'salt_lake_city_ut', label: 'Salt Lake City, UT', state: 'UT' },
  { value: 'tallahassee_fl', label: 'Tallahassee, FL', state: 'FL' },
  { value: 'huntsville_al', label: 'Huntsville, AL', state: 'AL' },
  { value: 'grand_prairie_tx', label: 'Grand Prairie, TX', state: 'TX' },
  { value: 'knoxville_tn', label: 'Knoxville, TN', state: 'TN' },
  { value: 'worcester_ma', label: 'Worcester, MA', state: 'MA' },
  { value: 'newport_news_va', label: 'Newport News, VA', state: 'VA' },
  { value: 'brownsville_tx', label: 'Brownsville, TX', state: 'TX' },
  { value: 'overland_park_ks', label: 'Overland Park, KS', state: 'KS' },
  { value: 'santa_clarita_ca', label: 'Santa Clarita, CA', state: 'CA' },
  { value: 'providence_ri', label: 'Providence, RI', state: 'RI' },
  { value: 'garden_grove_ca', label: 'Garden Grove, CA', state: 'CA' },
  { value: 'chattanooga_tn', label: 'Chattanooga, TN', state: 'TN' },
  { value: 'oceanside_ca', label: 'Oceanside, CA', state: 'CA' },
  { value: 'jackson_ms', label: 'Jackson, MS', state: 'MS' },
  { value: 'fort_lauderdale_fl', label: 'Fort Lauderdale, FL', state: 'FL' },
  { value: 'santa_rosa_ca', label: 'Santa Rosa, CA', state: 'CA' },
  { value: 'rancho_cucamonga_ca', label: 'Rancho Cucamonga, CA', state: 'CA' },
  { value: 'port_st_lucie_fl', label: 'Port St. Lucie, FL', state: 'FL' },
  { value: 'tempe_az', label: 'Tempe, AZ', state: 'AZ' },
  { value: 'ontario_ca', label: 'Ontario, CA', state: 'CA' },
  { value: 'vancouver_wa', label: 'Vancouver, WA', state: 'WA' },
  { value: 'cape_coral_fl', label: 'Cape Coral, FL', state: 'FL' },
  { value: 'sioux_falls_sd', label: 'Sioux Falls, SD', state: 'SD' },
  { value: 'springfield_mo', label: 'Springfield, MO', state: 'MO' },
  { value: 'peoria_az', label: 'Peoria, AZ', state: 'AZ' },
  { value: 'pembroke_pines_fl', label: 'Pembroke Pines, FL', state: 'FL' },
  { value: 'elk_grove_ca', label: 'Elk Grove, CA', state: 'CA' },
  { value: 'salem_or', label: 'Salem, OR', state: 'OR' },
  { value: 'lancaster_ca', label: 'Lancaster, CA', state: 'CA' },
  { value: 'corona_ca', label: 'Corona, CA', state: 'CA' },
  { value: 'eugene_or', label: 'Eugene, OR', state: 'OR' },
  { value: 'palmdale_ca', label: 'Palmdale, CA', state: 'CA' },
  { value: 'salinas_ca', label: 'Salinas, CA', state: 'CA' },
  { value: 'springfield_ma', label: 'Springfield, MA', state: 'MA' },
  { value: 'pasadena_tx', label: 'Pasadena, TX', state: 'TX' },
  { value: 'fort_collins_co', label: 'Fort Collins, CO', state: 'CO' },
  { value: 'hayward_ca', label: 'Hayward, CA', state: 'CA' },
  { value: 'pomona_ca', label: 'Pomona, CA', state: 'CA' },
  { value: 'cary_nc', label: 'Cary, NC', state: 'NC' },
  { value: 'rockford_il', label: 'Rockford, IL', state: 'IL' },
  { value: 'alexandria_va', label: 'Alexandria, VA', state: 'VA' },
  { value: 'escondido_ca', label: 'Escondido, CA', state: 'CA' },
  { value: 'mckinney_tx', label: 'McKinney, TX', state: 'TX' },
  { value: 'kansas_city_ks', label: 'Kansas City, KS', state: 'KS' },
  { value: 'joliet_il', label: 'Joliet, IL', state: 'IL' },
  { value: 'sunnyvale_ca', label: 'Sunnyvale, CA', state: 'CA' },
  { value: 'torrance_ca', label: 'Torrance, CA', state: 'CA' },
  { value: 'bridgeport_ct', label: 'Bridgeport, CT', state: 'CT' },
  { value: 'lakewood_co', label: 'Lakewood, CO', state: 'CO' },
  { value: 'hollywood_fl', label: 'Hollywood, FL', state: 'FL' },
  { value: 'paterson_nj', label: 'Paterson, NJ', state: 'NJ' },
  { value: 'naperville_il', label: 'Naperville, IL', state: 'IL' },
  { value: 'syracuse_ny', label: 'Syracuse, NY', state: 'NY' },
  { value: 'mesquite_tx', label: 'Mesquite, TX', state: 'TX' },
  { value: 'dayton_oh', label: 'Dayton, OH', state: 'OH' },
  { value: 'savannah_ga', label: 'Savannah, GA', state: 'GA' },
  { value: 'clarksville_tn', label: 'Clarksville, TN', state: 'TN' },
  { value: 'orange_ca', label: 'Orange, CA', state: 'CA' },
  { value: 'pasadena_ca', label: 'Pasadena, CA', state: 'CA' },
  { value: 'fullerton_ca', label: 'Fullerton, CA', state: 'CA' },
  { value: 'killeen_tx', label: 'Killeen, TX', state: 'TX' },
  { value: 'frisco_tx', label: 'Frisco, TX', state: 'TX' },
  { value: 'hampton_va', label: 'Hampton, VA', state: 'VA' },
  { value: 'mcallen_tx', label: 'McAllen, TX', state: 'TX' },
  { value: 'warren_mi', label: 'Warren, MI', state: 'MI' },
  { value: 'bellevue_wa', label: 'Bellevue, WA', state: 'WA' },
  { value: 'west_valley_city_ut', label: 'West Valley City, UT', state: 'UT' },
  { value: 'columbia_sc', label: 'Columbia, SC', state: 'SC' },
  { value: 'olathe_ks', label: 'Olathe, KS', state: 'KS' },
  { value: 'sterling_heights_mi', label: 'Sterling Heights, MI', state: 'MI' },
  { value: 'new_haven_ct', label: 'New Haven, CT', state: 'CT' },
  { value: 'miramar_fl', label: 'Miramar, FL', state: 'FL' },
  { value: 'waco_tx', label: 'Waco, TX', state: 'TX' },
  { value: 'thousand_oaks_ca', label: 'Thousand Oaks, CA', state: 'CA' },
  { value: 'cedar_rapids_ia', label: 'Cedar Rapids, IA', state: 'IA' },
  { value: 'charleston_sc', label: 'Charleston, SC', state: 'SC' },
  { value: 'visalia_ca', label: 'Visalia, CA', state: 'CA' },
  { value: 'topeka_ks', label: 'Topeka, KS', state: 'KS' },
  { value: 'elizabeth_nj', label: 'Elizabeth, NJ', state: 'NJ' },
  { value: 'gainesville_fl', label: 'Gainesville, FL', state: 'FL' },
  { value: 'thornton_co', label: 'Thornton, CO', state: 'CO' },
  { value: 'roseville_ca', label: 'Roseville, CA', state: 'CA' },
  { value: 'carrollton_tx', label: 'Carrollton, TX', state: 'TX' },
  { value: 'coral_springs_fl', label: 'Coral Springs, FL', state: 'FL' },
  { value: 'stamford_ct', label: 'Stamford, CT', state: 'CT' },
  { value: 'simi_valley_ca', label: 'Simi Valley, CA', state: 'CA' },
  { value: 'concord_ca', label: 'Concord, CA', state: 'CA' },
  { value: 'hartford_ct', label: 'Hartford, CT', state: 'CT' },
  { value: 'kent_wa', label: 'Kent, WA', state: 'WA' },
  { value: 'lafayette_la', label: 'Lafayette, LA', state: 'LA' },
  { value: 'midland_tx', label: 'Midland, TX', state: 'TX' },
  { value: 'surprise_az', label: 'Surprise, AZ', state: 'AZ' },
  { value: 'denton_tx', label: 'Denton, TX', state: 'TX' },
  { value: 'victorville_ca', label: 'Victorville, CA', state: 'CA' },
  { value: 'evansville_in', label: 'Evansville, IN', state: 'IN' },
  { value: 'santa_clara_ca', label: 'Santa Clara, CA', state: 'CA' },
  { value: 'abilene_tx', label: 'Abilene, TX', state: 'TX' },
  { value: 'athens_ga', label: 'Athens, GA', state: 'GA' },
  { value: 'vallejo_ca', label: 'Vallejo, CA', state: 'CA' },
  { value: 'allentown_pa', label: 'Allentown, PA', state: 'PA' },
  { value: 'norman_ok', label: 'Norman, OK', state: 'OK' },
  { value: 'beaumont_tx', label: 'Beaumont, TX', state: 'TX' },
  { value: 'independence_mo', label: 'Independence, MO', state: 'MO' },
  { value: 'murfreesboro_tn', label: 'Murfreesboro, TN', state: 'TN' },
  { value: 'ann_arbor_mi', label: 'Ann Arbor, MI', state: 'MI' },
  { value: 'springfield_il', label: 'Springfield, IL', state: 'IL' },
  { value: 'berkeley_ca', label: 'Berkeley, CA', state: 'CA' },
  { value: 'peoria_il', label: 'Peoria, IL', state: 'IL' },
  { value: 'provo_ut', label: 'Provo, UT', state: 'UT' },
  { value: 'el_monte_ca', label: 'El Monte, CA', state: 'CA' },
  { value: 'columbia_mo', label: 'Columbia, MO', state: 'MO' },
  { value: 'lansing_mi', label: 'Lansing, MI', state: 'MI' },
  { value: 'fargo_nd', label: 'Fargo, ND', state: 'ND' },
  { value: 'downey_ca', label: 'Downey, CA', state: 'CA' },
  { value: 'costa_mesa_ca', label: 'Costa Mesa, CA', state: 'CA' },
  { value: 'wilmington_nc', label: 'Wilmington, NC', state: 'NC' },
  { value: 'arvada_co', label: 'Arvada, CO', state: 'CO' },
  { value: 'inglewood_ca', label: 'Inglewood, CA', state: 'CA' },
  { value: 'miami_gardens_fl', label: 'Miami Gardens, FL', state: 'FL' },
  { value: 'carlsbad_ca', label: 'Carlsbad, CA', state: 'CA' },
  { value: 'westminster_co', label: 'Westminster, CO', state: 'CO' },
  { value: 'rochester_mn', label: 'Rochester, MN', state: 'MN' },
  { value: 'odessa_tx', label: 'Odessa, TX', state: 'TX' },
  { value: 'manchester_nh', label: 'Manchester, NH', state: 'NH' },
  { value: 'elgin_il', label: 'Elgin, IL', state: 'IL' },
  { value: 'west_jordan_ut', label: 'West Jordan, UT', state: 'UT' },
  { value: 'round_rock_tx', label: 'Round Rock, TX', state: 'TX' },
  { value: 'clearwater_fl', label: 'Clearwater, FL', state: 'FL' },
  { value: 'waterbury_ct', label: 'Waterbury, CT', state: 'CT' },
  { value: 'gresham_or', label: 'Gresham, OR', state: 'OR' },
  { value: 'fairfield_ca', label: 'Fairfield, CA', state: 'CA' },
  { value: 'billings_mt', label: 'Billings, MT', state: 'MT' },
  { value: 'lowell_ma', label: 'Lowell, MA', state: 'MA' },
  { value: 'san_buenaventura_ca', label: 'San Buenaventura, CA', state: 'CA' },
  { value: 'pueblo_co', label: 'Pueblo, CO', state: 'CO' },
  { value: 'high_point_nc', label: 'High Point, NC', state: 'NC' },
  { value: 'west_covina_ca', label: 'West Covina, CA', state: 'CA' },
  { value: 'richmond_ca', label: 'Richmond, CA', state: 'CA' },
  { value: 'murrieta_ca', label: 'Murrieta, CA', state: 'CA' },
  { value: 'cambridge_ma', label: 'Cambridge, MA', state: 'MA' },
  { value: 'antioch_ca', label: 'Antioch, CA', state: 'CA' },
  { value: 'temecula_ca', label: 'Temecula, CA', state: 'CA' },
  { value: 'norwalk_ca', label: 'Norwalk, CA', state: 'CA' },
  { value: 'centennial_co', label: 'Centennial, CO', state: 'CO' },
  { value: 'everett_wa', label: 'Everett, WA', state: 'WA' },
  { value: 'palm_bay_fl', label: 'Palm Bay, FL', state: 'FL' },
  { value: 'wichita_falls_tx', label: 'Wichita Falls, TX', state: 'TX' },
  { value: 'green_bay_wi', label: 'Green Bay, WI', state: 'WI' },
  { value: 'daly_city_ca', label: 'Daly City, CA', state: 'CA' },
  { value: 'burbank_ca', label: 'Burbank, CA', state: 'CA' },
  { value: 'richardson_tx', label: 'Richardson, TX', state: 'TX' },
  { value: 'pompano_beach_fl', label: 'Pompano Beach, FL', state: 'FL' },
  { value: 'north_charleston_sc', label: 'North Charleston, SC', state: 'SC' },
  { value: 'broken_arrow_ok', label: 'Broken Arrow, OK', state: 'OK' },
  { value: 'boulder_co', label: 'Boulder, CO', state: 'CO' },
  { value: 'west_palm_beach_fl', label: 'West Palm Beach, FL', state: 'FL' },
  { value: 'santa_maria_ca', label: 'Santa Maria, CA', state: 'CA' },
  { value: 'el_cajon_ca', label: 'El Cajon, CA', state: 'CA' },
  { value: 'davenport_ia', label: 'Davenport, IA', state: 'IA' },
  { value: 'rialto_ca', label: 'Rialto, CA', state: 'CA' },
  { value: 'las_cruces_nm', label: 'Las Cruces, NM', state: 'NM' },
  { value: 'san_mateo_ca', label: 'San Mateo, CA', state: 'CA' },
  { value: 'lewisville_tx', label: 'Lewisville, TX', state: 'TX' },
  { value: 'south_bend_in', label: 'South Bend, IN', state: 'IN' },
];

// US Regions and States data
const US_REGIONS = [
  { value: 'northeast', label: 'Northeast', states: ['ME', 'NH', 'VT', 'MA', 'RI', 'CT', 'NY', 'NJ', 'PA'] },
  { value: 'southeast', label: 'Southeast', states: ['DE', 'MD', 'VA', 'WV', 'NC', 'SC', 'GA', 'FL', 'KY', 'TN', 'AL', 'MS', 'AR', 'LA'] },
  { value: 'midwest', label: 'Midwest', states: ['OH', 'MI', 'IN', 'IL', 'WI', 'MN', 'IA', 'MO', 'ND', 'SD', 'NE', 'KS'] },
  { value: 'southwest', label: 'Southwest', states: ['TX', 'OK', 'NM', 'AZ'] },
  { value: 'west', label: 'West', states: ['CO', 'WY', 'MT', 'ID', 'UT', 'NV', 'CA', 'OR', 'WA', 'AK', 'HI'] },
];

const US_STATES = [
  { value: 'AL', label: 'Alabama' }, { value: 'AK', label: 'Alaska' }, { value: 'AZ', label: 'Arizona' },
  { value: 'AR', label: 'Arkansas' }, { value: 'CA', label: 'California' }, { value: 'CO', label: 'Colorado' },
  { value: 'CT', label: 'Connecticut' }, { value: 'DE', label: 'Delaware' }, { value: 'FL', label: 'Florida' },
  { value: 'GA', label: 'Georgia' }, { value: 'HI', label: 'Hawaii' }, { value: 'ID', label: 'Idaho' },
  { value: 'IL', label: 'Illinois' }, { value: 'IN', label: 'Indiana' }, { value: 'IA', label: 'Iowa' },
  { value: 'KS', label: 'Kansas' }, { value: 'KY', label: 'Kentucky' }, { value: 'LA', label: 'Louisiana' },
  { value: 'ME', label: 'Maine' }, { value: 'MD', label: 'Maryland' }, { value: 'MA', label: 'Massachusetts' },
  { value: 'MI', label: 'Michigan' }, { value: 'MN', label: 'Minnesota' }, { value: 'MS', label: 'Mississippi' },
  { value: 'MO', label: 'Missouri' }, { value: 'MT', label: 'Montana' }, { value: 'NE', label: 'Nebraska' },
  { value: 'NV', label: 'Nevada' }, { value: 'NH', label: 'New Hampshire' }, { value: 'NJ', label: 'New Jersey' },
  { value: 'NM', label: 'New Mexico' }, { value: 'NY', label: 'New York' }, { value: 'NC', label: 'North Carolina' },
  { value: 'ND', label: 'North Dakota' }, { value: 'OH', label: 'Ohio' }, { value: 'OK', label: 'Oklahoma' },
  { value: 'OR', label: 'Oregon' }, { value: 'PA', label: 'Pennsylvania' }, { value: 'RI', label: 'Rhode Island' },
  { value: 'SC', label: 'South Carolina' }, { value: 'SD', label: 'South Dakota' }, { value: 'TN', label: 'Tennessee' },
  { value: 'TX', label: 'Texas' }, { value: 'UT', label: 'Utah' }, { value: 'VT', label: 'Vermont' },
  { value: 'VA', label: 'Virginia' }, { value: 'WA', label: 'Washington' }, { value: 'WV', label: 'West Virginia' },
  { value: 'WI', label: 'Wisconsin' }, { value: 'WY', label: 'Wyoming' }
];

const RADIUS_OPTIONS = [
  { value: '25', label: '25 miles' },
  { value: '50', label: '50 miles' },
  { value: '75', label: '75 miles' },
  { value: '100', label: '100 miles' },
];

const LoadboardPage = () => {
  const { isAuthenticated } = useAuth();
  const [loads, setLoads] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('search');
  const [sortBy, setSortBy] = useState('newest');
  const [savedSearches, setSavedSearches] = useState([]);
  const [showSaveDialog, setShowSaveDialog] = useState(false);
  const [searchName, setSearchName] = useState('');
  const [showAdvancedFilters, setShowAdvancedFilters] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);
  
  // Enhanced search filters
  const [searchFilters, setSearchFilters] = useState({
    originCity: '',
    originState: '',
    originRegion: '',
    originRadius: '',
    destCity: '',
    destState: '',
    destRegion: '',
    destRadius: '',
    vehicleType: '',
    loadCategory: '',
    minPrice: '',
    maxPrice: '',
    verifiedOnly: false,
    includeReverse: false,
    carrierLocation: '', // For deadhead calculation
    paymentTerms: [], // COD, Check, Quick Pay, etc.
  });

  // Payment terms options
  const PAYMENT_TERMS = [
    { value: 'cod', label: 'COD' },
    { value: 'cop', label: 'COP' },
    { value: 'quick_pay', label: 'Quick Pay' },
    { value: 'check', label: 'Check' },
    { value: 'ach', label: 'ACH' },
    { value: 'factoring', label: 'Factoring' },
  ];

  const tabs = [
    { id: 'search', label: 'Search', icon: Search },
    { id: 'latest', label: 'Latest' },
    { id: 'saved', label: 'Saved Searches', icon: BookmarkCheck },
  ];

  useEffect(() => {
    loadLoads();
    if (isAuthenticated) {
      loadSavedSearches();
    }
  }, [isAuthenticated]);

  const loadLoads = async () => {
    setLoading(true);
    try {
      const response = await loadsAPI.search(searchFilters);
      setLoads(response.data || []);
    } catch (error) {
      console.error('Failed to load loads:', error);
      toast.error('Failed to load loads');
      setLoads([]);
    } finally {
      setLoading(false);
    }
  };

  const loadSavedSearches = async () => {
    try {
      const response = await savedSearchesAPI.getAll();
      setSavedSearches(response.data || []);
    } catch (error) {
      console.error('Failed to load saved searches');
    }
  };

  const handleSearch = () => {
    setHasSearched(true);
    loadLoads();
  };

  // Auto-search when quick filter category changes
  useEffect(() => {
    if (searchFilters.loadCategory !== undefined) {
      loadLoads();
    }
  }, [searchFilters.loadCategory]);

  const handleClearFilters = () => {
    setSearchFilters({
      originCity: '',
      originState: '',
      originRegion: '',
      originRadius: '',
      destCity: '',
      destState: '',
      destRegion: '',
      destRadius: '',
      vehicleType: '',
      loadCategory: '',
      minPrice: '',
      maxPrice: '',
      verifiedOnly: false,
      includeReverse: false,
      carrierLocation: '',
      paymentTerms: [],
    });
    setHasSearched(false);
  };

  const togglePaymentTerm = (term) => {
    setSearchFilters(prev => ({
      ...prev,
      paymentTerms: prev.paymentTerms.includes(term)
        ? prev.paymentTerms.filter(t => t !== term)
        : [...prev.paymentTerms, term]
    }));
  };

  const removeFilter = (filterType, value = null) => {
    if (filterType === 'paymentTerm' && value) {
      setSearchFilters(prev => ({
        ...prev,
        paymentTerms: prev.paymentTerms.filter(t => t !== value)
      }));
    } else {
      setSearchFilters(prev => ({
        ...prev,
        [filterType]: filterType === 'paymentTerms' ? [] : ''
      }));
    }
  };

  const handleSwapLocations = () => {
    setSearchFilters(prev => ({
      ...prev,
      originCity: prev.destCity,
      originState: prev.destState,
      originRegion: prev.destRegion,
      originRadius: prev.destRadius,
      destCity: prev.originCity,
      destState: prev.originState,
      destRegion: prev.originRegion,
      destRadius: prev.originRadius,
    }));
  };

  const handleSaveSearch = async () => {
    if (!searchName.trim()) {
      toast.error('Please enter a name for this search');
      return;
    }
    try {
      await savedSearchesAPI.create({ name: searchName, filters: searchFilters });
      toast.success('Search saved!');
      setShowSaveDialog(false);
      setSearchName('');
      loadSavedSearches();
    } catch (error) {
      toast.error('Failed to save search');
    }
  };

  const handleApplySavedSearch = (search) => {
    setSearchFilters(search.filters);
    setActiveTab('search');
    toast.success(`Applied: ${search.name}`);
    setTimeout(() => loadLoads(), 100);
  };

  const handleDeleteSavedSearch = async (searchId, e) => {
    e.stopPropagation();
    try {
      await savedSearchesAPI.delete(searchId);
      toast.success('Search deleted');
      loadSavedSearches();
    } catch (error) {
      toast.error('Failed to delete search');
    }
  };

  const getTimeAgo = (dateStr) => {
    const date = new Date(dateStr);
    const now = new Date();
    const diff = Math.floor((now - date) / 1000 / 60 / 60);
    if (diff < 1) return `${Math.floor((now - date) / 1000 / 60)}m`;
    if (diff < 24) return `${diff}h`;
    return `${Math.floor(diff / 24)}d`;
  };

  const getStatusBadge = (status, verified) => {
    if (verified) {
      return (
        <span className="status-verified px-2 py-0.5 rounded text-xs flex items-center gap-1">
          <Check className="w-3 h-3" />
          Verified
        </span>
      );
    }
    
    const badges = {
      posted: <span className="status-posted px-2 py-0.5 rounded text-xs">Posted</span>,
      assigned: <span className="status-assigned px-2 py-0.5 rounded text-xs">Assigned</span>,
      picked_up: <span className="status-in-transit px-2 py-0.5 rounded text-xs">In Transit</span>,
      delivered: <span className="status-completed px-2 py-0.5 rounded text-xs">Delivered</span>,
    };
    return badges[status] || <span className="status-assigned px-2 py-0.5 rounded text-xs">{status}</span>;
  };

  const getActiveFilterCount = () => {
    let count = 0;
    if (searchFilters.originCity || searchFilters.originState || searchFilters.originRegion) count++;
    if (searchFilters.destCity || searchFilters.destState || searchFilters.destRegion) count++;
    if (searchFilters.vehicleType) count++;
    if (searchFilters.loadCategory) count++;
    if (searchFilters.minPrice || searchFilters.maxPrice) count++;
    if (searchFilters.verifiedOnly) count++;
    if (searchFilters.paymentTerms.length > 0) count++;
    return count;
  };

  // Get active filters for sidebar display
  const getActiveFilters = () => {
    const filters = [];
    if (searchFilters.paymentTerms.length > 0) {
      searchFilters.paymentTerms.forEach(term => {
        const label = PAYMENT_TERMS.find(p => p.value === term)?.label || term;
        filters.push({ type: 'paymentTerm', value: term, label: `Payment: ${label}` });
      });
    }
    if (searchFilters.originCity) {
      filters.push({ type: 'originCity', label: `Origin: ${searchFilters.originCity}` });
    }
    if (searchFilters.originState) {
      const stateLabel = US_STATES.find(s => s.value === searchFilters.originState)?.label || searchFilters.originState;
      filters.push({ type: 'originState', label: `Origin: ${stateLabel}` });
    }
    if (searchFilters.originRegion) {
      const regionLabel = US_REGIONS.find(r => r.value === searchFilters.originRegion)?.label || searchFilters.originRegion;
      filters.push({ type: 'originRegion', label: `Origin: ${regionLabel}` });
    }
    if (searchFilters.destCity) {
      filters.push({ type: 'destCity', label: `Dest: ${searchFilters.destCity}` });
    }
    if (searchFilters.destState) {
      const stateLabel = US_STATES.find(s => s.value === searchFilters.destState)?.label || searchFilters.destState;
      filters.push({ type: 'destState', label: `Dest: ${stateLabel}` });
    }
    if (searchFilters.destRegion) {
      const regionLabel = US_REGIONS.find(r => r.value === searchFilters.destRegion)?.label || searchFilters.destRegion;
      filters.push({ type: 'destRegion', label: `Dest: ${regionLabel}` });
    }
    if (searchFilters.loadCategory) {
      filters.push({ type: 'loadCategory', label: `Type: ${searchFilters.loadCategory.replace('_', ' ')}` });
    }
    if (searchFilters.vehicleType) {
      filters.push({ type: 'vehicleType', label: `Vehicle: ${searchFilters.vehicleType.replace('_', ' ')}` });
    }
    if (searchFilters.verifiedOnly) {
      filters.push({ type: 'verifiedOnly', label: 'Verified Only' });
    }
    return filters;
  };

  return (
    <div className="min-h-screen bg-gray-100 pt-16">
      {/* Blue Header Banner */}
      <div className="bg-gradient-to-r from-[#0D1B2A] via-[#112240] to-[#0D1B2A] py-8 px-4">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <h1 className="text-3xl font-bold text-white" style={{fontFamily: 'Poppins, sans-serif'}}>Load Board</h1>
          <Button 
            variant="ghost" 
            size="sm" 
            onClick={loadLoads}
            className="text-gray-300 hover:text-white hover:bg-white/10"
            data-testid="refresh-loads-btn"
          >
            <RefreshCw className="w-4 h-4 mr-2" />
            Refresh
          </Button>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-6">

        {/* Tabs */}
        <div className="flex flex-wrap items-center gap-4 mb-8">
          <div className="flex items-center gap-3">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`px-5 py-2.5 rounded-xl text-sm font-medium transition-all flex items-center gap-2 ${
                  activeTab === tab.id
                    ? 'bg-gradient-to-r from-[#4ADE80] to-[#22C55E] text-[#000000] font-medium shadow-lg'
                    : 'text-[#111111] font-medium hover:text-[#000000] font-medium hover:bg-gray-100 border border-gray-200'
                }`}
                style={activeTab === tab.id ? {boxShadow: '0 4px 16px rgba(74, 222, 128, 0.4)'} : {}}
                data-testid={`tab-${tab.id}`}
              >
                {tab.icon && <tab.icon className="w-4 h-4" />}
                {tab.label}
              </button>
            ))}
          </div>

          <div className="ml-auto flex items-center gap-4 text-sm">
            {isAuthenticated && (
              <Dialog open={showSaveDialog} onOpenChange={setShowSaveDialog}>
                <DialogTrigger asChild>
                  <Button variant="ghost" size="sm" className="text-[#111111] font-medium hover:text-[#22C55E]">
                    <Save className="w-4 h-4 mr-2" />
                    Save Search
                  </Button>
                </DialogTrigger>
                <DialogContent className="bg-white border-gray-200" style={{boxShadow: '0 8px 40px rgba(0, 0, 0, 0.15)'}}>
                  <DialogHeader>
                    <DialogTitle className="text-xl text-[#000000] font-medium">Save This Search</DialogTitle>
                    <DialogDescription className="text-black font-medium">
                      Save your current filters for quick access later.
                    </DialogDescription>
                  </DialogHeader>
                  <div className="space-y-5 py-4">
                    <Input
                      placeholder="Search name (e.g., CA to TX Auto)"
                      value={searchName}
                      onChange={(e) => setSearchName(e.target.value)}
                      className="bg-gray-50 border-gray-200 h-12 text-[#000000] font-medium"
                      data-testid="save-search-name-input"
                    />
                    <div className="text-sm text-black font-medium">
                      Active filters: {getActiveFilterCount()}
                    </div>
                    <div className="flex gap-3 justify-end">
                      <Button variant="ghost" onClick={() => setShowSaveDialog(false)} className="text-black font-medium">
                        Cancel
                      </Button>
                      <Button onClick={handleSaveSearch} className="bg-gradient-to-r from-[#4ADE80] to-[#22C55E] text-[#000000] font-medium font-medium" data-testid="confirm-save-search-btn">
                        Save Search
                      </Button>
                    </div>
                  </div>
                </DialogContent>
              </Dialog>
            )}
            <span className="text-black font-medium">Sort:</span>
            <Select value={sortBy} onValueChange={setSortBy}>
              <SelectTrigger className="w-32 h-9 bg-white border-gray-200 text-[#000000] font-medium">
                <SelectValue />
              </SelectTrigger>
              <SelectContent className="bg-white border-gray-200">
                <SelectItem value="newest">Newest</SelectItem>
                <SelectItem value="price_high">Price High</SelectItem>
                <SelectItem value="price_low">Price Low</SelectItem>
              </SelectContent>
            </Select>
          </div>
        </div>

        {/* Search Panel */}
        {activeTab === 'search' && (
          <div className="mb-8 p-7 bg-white rounded-2xl border border-gray-200 shadow-sm">
            {/* Origin and Destination Search */}
            <div className="grid grid-cols-1 lg:grid-cols-[1fr,auto,1fr] gap-6 mb-6">
              {/* Origin */}
              <div className="space-y-5">
                <div className="flex items-center gap-2 text-[#22C55E]">
                  <MapPin className="w-5 h-5" />
                  <span className="font-semibold text-lg">Origin</span>
                </div>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <Label className="text-xs text-black font-medium uppercase tracking-wide">City</Label>
                    <Autocomplete
                      placeholder="Start typing city..."
                      value={searchFilters.originCity}
                      options={US_CITIES}
                      onChange={(value) => setSearchFilters({...searchFilters, originCity: value})}
                      onSelect={(option) => setSearchFilters({...searchFilters, originCity: option.label, originState: option.state, originRegion: ''})}
                      className="mt-2 h-11"
                      data-testid="origin-city-input"
                    />
                  </div>
                  <div>
                    <Label className="text-xs text-black font-medium uppercase tracking-wide">State</Label>
                    <Autocomplete
                      placeholder="Start typing state..."
                      value={searchFilters.originState ? US_STATES.find(s => s.value === searchFilters.originState)?.label || searchFilters.originState : ''}
                      options={US_STATES.map(s => ({ ...s, label: `${s.label} (${s.value})` }))}
                      onChange={(value) => {
                        const state = US_STATES.find(s => s.label.toLowerCase() === value.toLowerCase() || s.value.toLowerCase() === value.toLowerCase() || `${s.label} (${s.value})`.toLowerCase() === value.toLowerCase());
                        setSearchFilters({...searchFilters, originState: state?.value || '', originCity: '', originRegion: ''});
                      }}
                      onSelect={(option) => setSearchFilters({...searchFilters, originState: option.value.replace(/\s*\([^)]*\)/, ''), originCity: '', originRegion: ''})}
                      className="mt-2 h-11"
                      data-testid="origin-state-select"
                    />
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <Label className="text-xs text-black font-medium uppercase tracking-wide">Region</Label>
                    <Select 
                      value={searchFilters.originRegion || 'any'} 
                      onValueChange={(value) => setSearchFilters({...searchFilters, originRegion: value === 'any' ? '' : value, originCity: '', originState: ''})}
                    >
                      <SelectTrigger className="bg-white border-gray-300 mt-2 h-11 text-gray-900" data-testid="origin-region-select">
                        <SelectValue placeholder="Any region" />
                      </SelectTrigger>
                      <SelectContent className="bg-white border-gray-300 text-gray-900">
                        <SelectItem value="any" className="text-gray-900 hover:bg-gray-100 focus:bg-blue-50 focus:text-blue-900">Any region</SelectItem>
                        {US_REGIONS.map((region) => (
                          <SelectItem key={region.value} value={region.value} className="text-gray-900 hover:bg-gray-100 focus:bg-blue-50 focus:text-blue-900">
                            {region.label}
                          </SelectItem>
                        ))}
                      </SelectContent>
                    </Select>
                  </div>
                  <div>
                    <Label className="text-xs text-black font-medium uppercase tracking-wide">Radius</Label>
                    <Select 
                      value={searchFilters.originRadius || 'any'} 
                      onValueChange={(value) => setSearchFilters({...searchFilters, originRadius: value === 'any' ? '' : value})}
                    >
                      <SelectTrigger className="bg-white border-gray-300 mt-2 h-11 text-gray-900" data-testid="origin-radius-select">
                        <SelectValue placeholder="Any distance" />
                      </SelectTrigger>
                      <SelectContent className="bg-white border-gray-300 text-gray-900">
                        <SelectItem value="any" className="text-gray-900 hover:bg-gray-100 focus:bg-blue-50 focus:text-blue-900">Any distance</SelectItem>
                        {RADIUS_OPTIONS.map((opt) => (
                          <SelectItem key={opt.value} value={opt.value} className="text-gray-900 hover:bg-gray-100 focus:bg-blue-50 focus:text-blue-900">
                            {opt.label}
                          </SelectItem>
                        ))}
                      </SelectContent>
                    </Select>
                  </div>
                </div>
              </div>

              {/* Swap Button */}
              <div className="flex items-center justify-center lg:pt-8">
                <Button
                  type="button"
                  variant="outline"
                  size="icon"
                  onClick={handleSwapLocations}
                  className="w-12 h-12 rounded-full border-[#3B82F6]/30 bg-[#0D1B2A] hover:bg-[#3B82F6]/20 hover:border-[#3B82F6] transition-all"
                  title="Swap origin and destination"
                  data-testid="swap-locations-btn"
                >
                  <ArrowLeftRight className="w-5 h-5 text-[#60A5FA]" />
                </Button>
              </div>

              {/* Destination */}
              <div className="space-y-5">
                <div className="flex items-center gap-2 text-[#60A5FA]">
                  <Navigation className="w-5 h-5" />
                  <span className="font-semibold text-lg">Destination</span>
                </div>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <Label className="text-xs text-black font-medium uppercase tracking-wide">City</Label>
                    <Autocomplete
                      placeholder="Start typing city..."
                      value={searchFilters.destCity}
                      options={US_CITIES}
                      onChange={(value) => setSearchFilters({...searchFilters, destCity: value})}
                      onSelect={(option) => setSearchFilters({...searchFilters, destCity: option.label, destState: option.state, destRegion: ''})}
                      className="mt-2 h-11"
                      data-testid="dest-city-input"
                    />
                  </div>
                  <div>
                    <Label className="text-xs text-black font-medium uppercase tracking-wide">State</Label>
                    <Autocomplete
                      placeholder="Start typing state..."
                      value={searchFilters.destState ? US_STATES.find(s => s.value === searchFilters.destState)?.label || searchFilters.destState : ''}
                      options={US_STATES.map(s => ({ ...s, label: `${s.label} (${s.value})` }))}
                      onChange={(value) => {
                        const state = US_STATES.find(s => s.label.toLowerCase() === value.toLowerCase() || s.value.toLowerCase() === value.toLowerCase() || `${s.label} (${s.value})`.toLowerCase() === value.toLowerCase());
                        setSearchFilters({...searchFilters, destState: state?.value || '', destCity: '', destRegion: ''});
                      }}
                      onSelect={(option) => setSearchFilters({...searchFilters, destState: option.value.replace(/\s*\([^)]*\)/, ''), destCity: '', destRegion: ''})}
                      className="mt-2 h-11"
                      data-testid="dest-state-select"
                    />
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <Label className="text-xs text-black font-medium uppercase tracking-wide">Region</Label>
                    <Select 
                      value={searchFilters.destRegion || 'any'} 
                      onValueChange={(value) => setSearchFilters({...searchFilters, destRegion: value === 'any' ? '' : value, destCity: '', destState: ''})}
                    >
                      <SelectTrigger className="bg-white border-gray-300 mt-2 h-11 text-gray-900" data-testid="dest-region-select">
                        <SelectValue placeholder="Any region" />
                      </SelectTrigger>
                      <SelectContent className="bg-white border-gray-300 text-gray-900">
                        <SelectItem value="any" className="text-gray-900 hover:bg-gray-100 focus:bg-blue-50 focus:text-blue-900">Any region</SelectItem>
                        {US_REGIONS.map((region) => (
                          <SelectItem key={region.value} value={region.value} className="text-gray-900 hover:bg-gray-100 focus:bg-blue-50 focus:text-blue-900">
                            {region.label}
                          </SelectItem>
                        ))}
                      </SelectContent>
                    </Select>
                  </div>
                  <div>
                    <Label className="text-xs text-black font-medium uppercase tracking-wide">Radius</Label>
                    <Select 
                      value={searchFilters.destRadius || 'any'} 
                      onValueChange={(value) => setSearchFilters({...searchFilters, destRadius: value === 'any' ? '' : value})}
                    >
                      <SelectTrigger className="bg-white border-gray-300 mt-2 h-11 text-gray-900" data-testid="dest-radius-select">
                        <SelectValue placeholder="Any distance" />
                      </SelectTrigger>
                      <SelectContent className="bg-white border-gray-300 text-gray-900">
                        <SelectItem value="any" className="text-gray-900 hover:bg-gray-100 focus:bg-blue-50 focus:text-blue-900">Any distance</SelectItem>
                        {RADIUS_OPTIONS.map((opt) => (
                          <SelectItem key={opt.value} value={opt.value} className="text-gray-900 hover:bg-gray-100 focus:bg-blue-50 focus:text-blue-900">
                            {opt.label}
                          </SelectItem>
                        ))}
                      </SelectContent>
                    </Select>
                  </div>
                </div>
              </div>
            </div>

            {/* Include Reverse Route Option */}
            <div className="flex items-center gap-3 mb-6 p-4 bg-white rounded-lg border border-gray-300 shadow-sm">
              <label className="flex items-center gap-3 cursor-pointer flex-1">
                <input
                  type="checkbox"
                  checked={searchFilters.includeReverse}
                  onChange={(e) => setSearchFilters({...searchFilters, includeReverse: e.target.checked})}
                  className="w-5 h-5 rounded border-gray-300 bg-white text-[#3B82F6] focus:ring-[#3B82F6]"
                  data-testid="include-reverse-checkbox"
                />
                <div>
                  <span className="text-[#0D1B2A] font-medium">Include Reverse Route</span>
                  <p className="text-xs text-gray-500 mt-0.5">Also show loads going in the opposite direction</p>
                </div>
              </label>
              <ArrowLeftRight className="w-5 h-5 text-[#3B82F6]" />
            </div>

            {/* Advanced Filters Toggle */}
            <button
              onClick={() => setShowAdvancedFilters(!showAdvancedFilters)}
              className="flex items-center gap-2 text-sm text-[#60A5FA] hover:text-[#93C5FD] mb-4 font-medium"
              data-testid="toggle-advanced-filters"
            >
              <Filter className="w-4 h-4" />
              Advanced Filters
              {showAdvancedFilters ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
            </button>

            {/* Advanced Filters */}
            {showAdvancedFilters && (
              <div className="grid grid-cols-2 md:grid-cols-4 gap-5 mb-6 pt-5 border-t border-gray-200">
                <div>
                  <Label className="text-xs text-black font-medium uppercase tracking-wide">Vehicle Type</Label>
                  <Select 
                    value={searchFilters.vehicleType || 'any'} 
                    onValueChange={(value) => setSearchFilters({...searchFilters, vehicleType: value === 'any' ? '' : value})}
                  >
                    <SelectTrigger className="bg-white border-gray-300 mt-2 h-11 text-gray-900">
                      <SelectValue placeholder="Any type" />
                    </SelectTrigger>
                    <SelectContent className="bg-white border-gray-300 text-gray-900">
                      <SelectItem value="any" className="text-gray-900 hover:bg-gray-100 focus:bg-blue-50 focus:text-blue-900">Any type</SelectItem>
                      <SelectItem value="open_carrier" className="text-gray-900 hover:bg-gray-100 focus:bg-blue-50 focus:text-blue-900">Open Carrier</SelectItem>
                      <SelectItem value="enclosed_carrier" className="text-gray-900 hover:bg-gray-100 focus:bg-blue-50 focus:text-blue-900">Enclosed Carrier</SelectItem>
                      <SelectItem value="hotshot" className="text-gray-900 hover:bg-gray-100 focus:bg-blue-50 focus:text-blue-900">Hotshot</SelectItem>
                      <SelectItem value="driveaway" className="text-gray-900 hover:bg-gray-100 focus:bg-blue-50 focus:text-blue-900">Driveaway</SelectItem>
                      <SelectItem value="flatbed" className="text-gray-900 hover:bg-gray-100 focus:bg-blue-50 focus:text-blue-900">Flatbed</SelectItem>
                    </SelectContent>
                  </Select>
                </div>
                <div>
                  <Label className="text-xs text-black font-medium uppercase tracking-wide">Load Category</Label>
                  <Select 
                    value={searchFilters.loadCategory || 'any'} 
                    onValueChange={(value) => setSearchFilters({...searchFilters, loadCategory: value === 'any' ? '' : value})}
                  >
                    <SelectTrigger className="bg-white border-gray-300 mt-2 h-11 text-gray-900">
                      <SelectValue placeholder="Any category" />
                    </SelectTrigger>
                    <SelectContent className="bg-white border-gray-300 text-gray-900">
                      <SelectItem value="any" className="text-gray-900 hover:bg-gray-100 focus:bg-blue-50 focus:text-blue-900">Any category</SelectItem>
                      <SelectItem value="auto_transport" className="text-gray-900 hover:bg-gray-100 focus:bg-blue-50 focus:text-blue-900">Auto Transport</SelectItem>
                      <SelectItem value="hotshot" className="text-gray-900 hover:bg-gray-100 focus:bg-blue-50 focus:text-blue-900">Hotshot</SelectItem>
                      <SelectItem value="freight" className="text-gray-900 hover:bg-gray-100 focus:bg-blue-50 focus:text-blue-900">Freight</SelectItem>
                    </SelectContent>
                  </Select>
                </div>
                <div>
                  <Label className="text-xs text-black font-medium uppercase tracking-wide">Min Price</Label>
                  <Input
                    type="number"
                    placeholder="$0"
                    value={searchFilters.minPrice}
                    onChange={(e) => setSearchFilters({...searchFilters, minPrice: e.target.value})}
                    className="bg-white border-gray-300 mt-2 h-11 text-gray-900"
                  />
                </div>
                <div>
                  <Label className="text-xs text-black font-medium uppercase tracking-wide">Max Price</Label>
                  <Input
                    type="number"
                    placeholder="$10,000+"
                    value={searchFilters.maxPrice}
                    onChange={(e) => setSearchFilters({...searchFilters, maxPrice: e.target.value})}
                    className="bg-white border-gray-300 mt-2 h-11 text-gray-900"
                  />
                </div>
                <div className="col-span-2 md:col-span-4">
                  <Label className="text-xs text-black font-medium uppercase tracking-wide flex items-center gap-2">
                    <Truck className="w-4 h-4 text-[#60A5FA]" />
                    Your Current Location (for Deadhead Calculation)
                  </Label>
                  <Input
                    placeholder="e.g., Chicago, IL"
                    value={searchFilters.carrierLocation}
                    onChange={(e) => setSearchFilters({...searchFilters, carrierLocation: e.target.value})}
                    className="bg-white border-gray-300 mt-2 h-11 text-gray-900"
                    data-testid="carrier-location-input"
                  />
                  <p className="text-xs text-gray-600 mt-1.5">Enter your location to see empty miles to each pickup</p>
                </div>
              </div>
            )}

            {/* Search Actions */}
            <div className="flex items-center justify-between pt-5 border-t border-gray-200">
              <div className="flex items-center gap-4">
                <label className="flex items-center gap-2.5 text-sm text-black font-medium cursor-pointer">
                  <input
                    type="checkbox"
                    checked={searchFilters.verifiedOnly}
                    onChange={(e) => setSearchFilters({...searchFilters, verifiedOnly: e.target.checked})}
                    className="rounded border-[#3B82F6]/30 bg-gray-50 text-[#4ADE80] focus:ring-[#4ADE80]"
                  />
                  Verified posters only
                </label>
                {getActiveFilterCount() > 0 && (
                  <Button
                    variant="ghost"
                    size="sm"
                    onClick={handleClearFilters}
                    className="text-black font-medium hover:text-[#000000] font-medium"
                    data-testid="clear-filters-btn"
                  >
                    <X className="w-4 h-4 mr-1" />
                    Clear filters
                  </Button>
                )}
              </div>
              <Button 
                onClick={handleSearch} 
                className="bg-gradient-to-r from-[#4ADE80] to-[#22C55E] hover:from-[#86EFAC] hover:to-[#4ADE80] text-[#000000] font-medium font-semibold px-10 h-12"
                style={{boxShadow: '0 4px 16px rgba(74, 222, 128, 0.4)'}}
                data-testid="search-loads-btn"
              >
                <Search className="w-4 h-4 mr-2" />
                Search Loads
              </Button>
            </div>
          </div>
        )}

        {/* Saved Searches Panel */}
        {activeTab === 'saved' && isAuthenticated && (
          <div className="mb-8 p-6 bg-white rounded-2xl border border-gray-200">
            <h3 className="text-xl font-semibold text-[#000000] font-medium mb-5">Your Saved Searches</h3>
            {savedSearches.length === 0 ? (
              <p className="text-black font-medium">No saved searches yet. Use the "Save Search" button to save your current filters.</p>
            ) : (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {savedSearches.map((search) => (
                  <div
                    key={search.id}
                    onClick={() => handleApplySavedSearch(search)}
                    className="p-4 bg-gray-50 rounded-xl border border-gray-200 hover:border-[#4ADE80]/50 cursor-pointer transition-all group hover:-translate-y-1"
                    data-testid={`saved-search-${search.id}`}
                  >
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-2.5">
                        <Bookmark className="w-5 h-5 text-[#4ADE80]" />
                        <span className="text-[#000000] font-medium font-medium">{search.name}</span>
                      </div>
                      <button
                        onClick={(e) => handleDeleteSavedSearch(search.id, e)}
                        className="opacity-0 group-hover:opacity-100 text-black font-medium hover:text-red-400 transition-opacity"
                      >
                        <X className="w-4 h-4" />
                      </button>
                    </div>
                    <p className="text-xs text-gray-700 mt-2">
                      Created {new Date(search.created_at).toLocaleDateString()}
                    </p>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {/* Quick Category Filter Buttons */}
        <div className="flex items-center gap-3 mb-5">
          <span className="text-sm text-black font-medium mr-2">Quick Filter:</span>
          <button
            onClick={() => setSearchFilters({...searchFilters, loadCategory: ''})}
            className={`px-4 py-2 rounded-lg text-sm font-medium transition-all ${
              !searchFilters.loadCategory 
                ? 'bg-[#3B82F6] text-white font-semibold shadow-lg shadow-blue-500/25' 
                : 'bg-white text-black font-medium border border-gray-200 hover:border-[#3B82F6]/50'
            }`}
            data-testid="filter-all-btn"
          >
            All Loads
          </button>
          <button
            onClick={() => setSearchFilters({...searchFilters, loadCategory: 'auto_transport'})}
            className={`px-4 py-2 rounded-lg text-sm font-medium transition-all flex items-center gap-2 ${
              searchFilters.loadCategory === 'auto_transport'
                ? 'bg-blue-500 text-white font-semibold shadow-lg shadow-blue-500/25' 
                : 'bg-white text-black font-medium border border-gray-200 hover:border-blue-500/50 hover:text-blue-600'
            }`}
            data-testid="filter-auto-btn"
          >
            🚗 Auto Transport
          </button>
          <button
            onClick={() => setSearchFilters({...searchFilters, loadCategory: 'hotshot'})}
            className={`px-4 py-2 rounded-lg text-sm font-medium transition-all flex items-center gap-2 ${
              searchFilters.loadCategory === 'hotshot'
                ? 'bg-yellow-500 text-white font-semibold shadow-lg shadow-yellow-500/25' 
                : 'bg-white text-black font-medium border border-gray-200 hover:border-yellow-500/50 hover:text-yellow-600'
            }`}
            data-testid="filter-hotshot-btn"
          >
            ⚡ Hotshot
          </button>
          <button
            onClick={() => setSearchFilters({...searchFilters, loadCategory: 'freight'})}
            className={`px-4 py-2 rounded-lg text-sm font-medium transition-all flex items-center gap-2 ${
              searchFilters.loadCategory === 'freight'
                ? 'bg-green-500 text-white font-semibold shadow-lg shadow-green-500/25' 
                : 'bg-white text-black font-medium border border-gray-200 hover:border-green-500/50 hover:text-green-600'
            }`}
            data-testid="filter-freight-btn"
          >
            📦 Freight
          </button>
        </div>

        {/* Main Content with Sidebar */}
        <div className="flex gap-6">
          {/* Left Sidebar - Search Filters */}
          <div className="w-64 flex-shrink-0">
            <div className="bg-white rounded-xl border border-gray-200 shadow-sm sticky top-20">
                {/* Saved Searches Section */}
                {savedSearches.length > 0 && (
                  <div className="p-4 border-b border-gray-200">
                    <h3 className="text-sm font-semibold text-[#3B82F6] flex items-center gap-2 mb-3">
                      <Bookmark className="w-4 h-4" />
                      SAVED SEARCHES
                    </h3>
                    <div className="space-y-2">
                      {savedSearches.slice(0, 3).map((search) => (
                        <button
                          key={search.id}
                          onClick={() => handleApplySavedSearch(search)}
                          className="w-full text-left p-2 rounded-lg bg-gray-50 hover:bg-gray-100 text-sm text-[#0D1B2A] flex items-center justify-between group"
                        >
                          <span className="truncate">{search.name}</span>
                          <ArrowRight className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity" />
                        </button>
                      ))}
                    </div>
                    {savedSearches.length > 3 && (
                      <button className="text-xs text-[#3B82F6] mt-2 hover:underline">
                        View All ({savedSearches.length})
                      </button>
                    )}
                  </div>
                )}

                {/* Current Search Filters */}
                <div className="p-4 border-b border-gray-200">
                  <h3 className="text-sm font-semibold text-[#3B82F6] flex items-center gap-2 mb-3">
                    <Filter className="w-4 h-4" />
                    CURRENT SEARCH
                  </h3>
                  {getActiveFilters().length > 0 ? (
                    <div className="space-y-2">
                      {getActiveFilters().map((filter, idx) => (
                        <div
                          key={idx}
                          className="flex items-center justify-between py-1.5 px-2 bg-gray-50 rounded-lg text-sm"
                        >
                          <span className="text-[#0D1B2A] truncate">{filter.label}</span>
                          <button
                            onClick={() => removeFilter(filter.type, filter.value)}
                            className="text-gray-400 hover:text-red-500 ml-2 flex-shrink-0"
                          >
                            <X className="w-3.5 h-3.5" />
                          </button>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <p className="text-sm text-gray-500">No filters applied</p>
                  )}
                  <div className="flex gap-2 mt-3">
                    <Button
                      variant="outline"
                      size="sm"
                      onClick={handleClearFilters}
                      className="flex-1 text-xs border-gray-300"
                    >
                      <X className="w-3 h-3 mr-1" />
                      Clear
                    </Button>
                    {isAuthenticated && (
                      <Button
                        variant="outline"
                        size="sm"
                        onClick={() => setShowSaveDialog(true)}
                        className="flex-1 text-xs border-gray-300"
                      >
                        <Save className="w-3 h-3 mr-1" />
                        Save
                      </Button>
                    )}
                  </div>
                </div>

                {/* Payment Terms Filter */}
                <div className="p-4">
                  <h3 className="text-sm font-semibold text-[#3B82F6] flex items-center gap-2 mb-3">
                    💳 PAYMENT TERMS
                  </h3>
                  <div className="space-y-2">
                    {PAYMENT_TERMS.map((term) => (
                      <label
                        key={term.value}
                        className="flex items-center gap-2 cursor-pointer text-sm text-[#0D1B2A] hover:bg-gray-50 p-1.5 rounded"
                      >
                        <input
                          type="checkbox"
                          checked={searchFilters.paymentTerms.includes(term.value)}
                          onChange={() => togglePaymentTerm(term.value)}
                          className="rounded border-gray-300 text-[#3B82F6] focus:ring-[#3B82F6]"
                        />
                        {term.label}
                      </label>
                    ))}
                  </div>
                </div>

                {/* Location Summary */}
                {(searchFilters.originCity || searchFilters.originState || searchFilters.destCity || searchFilters.destState) && (
                  <div className="p-4 border-t border-gray-200">
                    <h3 className="text-sm font-semibold text-[#3B82F6] flex items-center gap-2 mb-3">
                      <MapPin className="w-4 h-4" />
                      LOCATION
                    </h3>
                    {(searchFilters.originCity || searchFilters.originState) && (
                      <div className="mb-2">
                        <p className="text-xs text-gray-500 uppercase">Origin</p>
                        <p className="text-sm text-[#0D1B2A] flex items-center gap-1">
                          <span className="w-2 h-2 rounded-full bg-green-500"></span>
                          {searchFilters.originCity || US_STATES.find(s => s.value === searchFilters.originState)?.label || searchFilters.originState}
                        </p>
                      </div>
                    )}
                    {(searchFilters.destCity || searchFilters.destState) && (
                      <div>
                        <p className="text-xs text-gray-500 uppercase">Destination</p>
                        <p className="text-sm text-[#0D1B2A] flex items-center gap-1">
                          <span className="w-2 h-2 rounded-full bg-red-500"></span>
                          {searchFilters.destCity || US_STATES.find(s => s.value === searchFilters.destState)?.label || searchFilters.destState}
                        </p>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          <div className="flex-1 min-w-0">
            {/* Results Count */}
            <div className="flex items-center justify-between mb-5">
              <span className="text-sm text-black font-medium">
                {loading ? 'Loading...' : `${loads.length} loads found`}
              </span>
            </div>

            {/* Table */}
            <div className="bg-white rounded-2xl border border-gray-200 overflow-hidden" style={{boxShadow: '0 8px 32px rgba(59, 130, 246, 0.1)'}}>
              <table className="loadboard-table">
                <thead className="bg-gray-100">
              <tr>
                <th>Category</th>
                <th>Origin</th>
                <th></th>
                <th>Destination</th>
                <th>Details</th>
                <th>Trailer</th>
                <th>Price</th>
                <th>Miles</th>
                <th>Deadhead</th>
                <th>Age</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="11" className="text-center py-16">
                    <Loader2 className="w-8 h-8 animate-spin mx-auto text-[#60A5FA]" />
                  </td>
                </tr>
              ) : loads.length === 0 ? (
                <tr>
                  <td colSpan="11" className="text-center py-16 text-black font-medium">
                    No loads found matching your criteria
                  </td>
                </tr>
              ) : (
                loads.map((load) => (
                  <tr 
                    key={load.id}
                    onClick={() => window.location.href = `/loads/${load.id}`}
                    data-testid={`load-row-${load.id}`}
                  >
                    <td>
                      {load.load_category === 'auto_transport' && (
                        <span className="inline-flex items-center px-2 py-1 rounded text-xs font-medium bg-blue-500/20 text-blue-400 border border-blue-500/30">
                          🚗 Auto
                        </span>
                      )}
                      {load.load_category === 'hotshot' && (
                        <span className="inline-flex items-center px-2 py-1 rounded text-xs font-medium bg-yellow-500/20 text-yellow-400 border border-yellow-500/30">
                          ⚡ Hotshot
                        </span>
                      )}
                      {load.load_category === 'freight' && (
                        <span className="inline-flex items-center px-2 py-1 rounded text-xs font-medium bg-green-500/20 text-green-400 border border-green-500/30">
                          📦 Freight
                        </span>
                      )}
                    </td>
                    <td>
                      <div>
                        <span className="text-[#000000] font-medium font-medium">{load.pickup_location}</span>
                        <div className="text-xs text-gray-700 mt-0.5">{load.id.slice(0, 5)}</div>
                      </div>
                    </td>
                    <td className="text-[#60A5FA]">
                      <ArrowRight className="w-4 h-4" />
                    </td>
                    <td>
                      <div>
                        <span className="text-[#000000] font-medium font-medium">{load.delivery_location}</span>
                        <div className="text-xs text-gray-700 mt-0.5">{load.id.slice(5, 10)}</div>
                      </div>
                    </td>
                    <td className="text-black font-medium">
                      {load.load_category === 'auto_transport' ? (
                        load.vehicle_make_model || `${load.vehicle_count} vehicle(s)`
                      ) : load.load_category === 'hotshot' ? (
                        load.weight ? `${load.weight.toLocaleString()} lbs` : 'Weight TBD'
                      ) : (
                        load.weight ? `${load.weight.toLocaleString()} lbs${load.pallet_count ? ` / ${load.pallet_count} pallets` : ''}` : 'Details TBD'
                      )}
                    </td>
                    <td className="text-black font-medium capitalize">
                      {load.load_category === 'hotshot' && load.trailer_type 
                        ? load.trailer_type.replace('_', ' ')
                        : load.vehicle_type?.replace('_', ' ') || 'Open'}
                    </td>
                    <td className="text-[#4ADE80] font-bold text-base">
                      <div>
                        ${load.price?.toLocaleString() || '0'}
                        {load.rate_per_mile && (
                          <div className="text-xs text-gray-700 font-normal">
                            ${load.rate_per_mile.toFixed(2)}/mi
                          </div>
                        )}
                      </div>
                    </td>
                    <td className="text-black font-medium">
                      {load.mileage ? (
                        <span>{load.mileage.toLocaleString()} mi</span>
                      ) : (
                        <span className="text-gray-700">-</span>
                      )}
                    </td>
                    <td className="text-black font-medium">
                      {load.deadhead_miles !== null && load.deadhead_miles !== undefined ? (
                        <div>
                          <span className="text-orange-400">{load.deadhead_miles.toLocaleString()} mi</span>
                          {load.effective_rpm && (
                            <div className="text-xs text-gray-700 mt-0.5">
                              Eff: ${load.effective_rpm.toFixed(2)}/mi
                            </div>
                          )}
                        </div>
                      ) : (
                        <span className="text-gray-700">-</span>
                      )}
                    </td>
                    <td className="text-gray-700">
                      {getTimeAgo(load.created_at)}
                    </td>
                    <td>
                      {getStatusBadge(load.status, load.poster_profile?.verification_status === 'verified')}
                    </td>
                  </tr>
                ))
              )}
              </tbody>
            </table>
          
            {/* Pagination */}
            <div className="flex items-center justify-between px-6 py-4 border-t border-gray-200 text-sm text-black font-medium">
              <div className="flex items-center gap-3">
                <button className="p-2 hover:text-[#000000] font-medium disabled:opacity-50 transition-colors" disabled>◀</button>
                <button className="p-2 hover:text-[#000000] font-medium disabled:opacity-50 transition-colors" disabled>▶</button>
              </div>
              <span>1 to {Math.min(50, loads.length)} of {loads.length}+ results</span>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadboardPage;
